<template>
  <div class="background" ref="card" >
    <a-card class="card" >
      <div>
        <div class="logo-wrap">
          <img :src="logo" width="100" />
        </div>
        <div class="title">
          <span>RoadTrack</span>
        </div>
        <div class="subtitle">
          <span>道路裂纹自动检测系统</span>
        </div>
      </div>
      <router-view />
    </a-card>
  </div>
</template>

<script>
export default {
  name: "UserLayout",
  data() {
    return {
      logo: require("@/assets/logo.png")
    };
  },
  methods: {
  },
};
</script>

<style scoped>
.card {
  width: min(580px, calc(100vw - 32px));
  border-radius: 8px;
  padding-bottom: 64px;
  margin: auto;
}

.background {
  min-height: 100%;
  padding: 10vh 0;
  background: url("https://vkceyugu.cdn.bspapp.com/VKCEYUGU-c84ba6b8-76a1-4911-86f7-95839ee7bd57/eb70a786-4162-441b-b497-49a6ce8caa0d.jpg") center center / cover no-repeat;
}

.logo-wrap {
  text-align: center;
  padding-top: 16px;
}

.logo-wrap img {
  cursor: pointer;
  margin-top: 16px;
}

.title {
  text-align: center;
  color: #1890ff;
  margin-top: 16px;
  font-weight: bold;
}

.title span {
  cursor: pointer;
  font-size: 24px;
}

.subtitle {
  text-align: center;
  font-size: 16px;
  color: #1890ff;
  margin-top: 8px;
  margin-bottom: 24px;
}

@media (max-width: 768px) {
  .background {
    min-height: 100%;
    padding: 16px 0;
  }

  .card {
    width: calc(100vw - 24px);
    padding-bottom: 28px;
  }

  .logo-wrap {
    padding-top: 4px;
  }

  .logo-wrap img {
    width: 72px;
    margin-top: 8px;
  }

  .title span {
    font-size: 22px;
  }

  .subtitle {
    font-size: 14px;
    margin-bottom: 18px;
  }
}
</style>
